var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"regular-tables","fluid":"","tag":"section"}})
}
var staticRenderFns = []

export { render, staticRenderFns }